module.exports = __webpack_public_path__ + "static/media/wizualizacja-131.1ea3b284.png";